import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createBlock as _createBlock, createTextVNode as _createTextVNode } from "vue";
const _hoisted_1 = { class: "container" };
const _hoisted_2 = { class: "row" };
const _hoisted_3 = { class: "col-12 fw-bold mb-2" };
const _hoisted_4 = { class: "container p-0 product-configurator" };
const _hoisted_5 = {
    key: 0,
    class: "row ms-2 me-2"
};
const _hoisted_6 = { class: "col-12" };
const _hoisted_7 = {
    class: "btn-group w-100 mb-3",
    role: "group",
    "aria-label": "Basic radio toggle button group"
};
const _hoisted_8 = ["id", "value"];
const _hoisted_9 = ["for"];
const _hoisted_10 = { class: "col-12" };
const _hoisted_11 = {
    style: { "border": "1px solid #ddd", "background-color": "#f9fafb" },
    class: "p-2 d-flex"
};
const _hoisted_12 = { class: "ms-auto me-0" };
const _hoisted_13 = {
    style: { "border": "1px solid #ddd", "border-top": "1px solid transparent" },
    class: "container p-2 mb-2"
};
const _hoisted_14 = { class: "row m-0 pt-1 pb-1" };
const _hoisted_15 = { class: "col-1 text-center" };
const _hoisted_16 = { class: "col-8" };
const _hoisted_17 = {
    key: 0,
    class: "text-muted small"
};
const _hoisted_18 = {
    key: 1,
    class: "text-danger small"
};
const _hoisted_19 = { class: "col-3 text-end" };
const _hoisted_20 = {
    key: 0,
    class: "row m-0 pt-2 pb-1"
};
const _hoisted_21 = { class: "col-11" };
const _hoisted_22 = {
    key: 0,
    class: "text-muted small"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_g_icon = _resolveComponent("g-icon");
    const _component_g_link = _resolveComponent("g-link");
    const _component_DxCheckBox = _resolveComponent("DxCheckBox");
    const _component_g_product_delivery_time = _resolveComponent("g-product-delivery-time");
    const _component_g_text_field = _resolveComponent("g-text-field");
    return (_ctx.product.configurationType === 'cards' && _ctx.configurator.hasConfiguration)
        ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
            _createElementVNode("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, _toDisplayString(_ctx.$t('client.Commerce.Products.AdditionalOptionsTitle')) + ": ", 1)
                ])
            ]),
            _createElementVNode("div", _hoisted_4, [
                (_ctx.configurator.scopes.length > 0)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                        _createElementVNode("div", _hoisted_6, [
                            _createElementVNode("div", _hoisted_7, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configurator.scopes, (scope) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, null, [
                                        _withDirectives(_createElementVNode("input", {
                                            type: "radio",
                                            class: "btn-check",
                                            name: "btnConfigScope",
                                            id: 'btnConfigScope' + scope.name,
                                            autocomplete: "off",
                                            value: scope.name,
                                            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((_ctx.configurationMode) = $event))
                                        }, null, 8, _hoisted_8), [
                                            [_vModelRadio, _ctx.configurationMode]
                                        ]),
                                        _createElementVNode("label", {
                                            class: "btn btn-outline-secondary",
                                            for: 'btnConfigScope' + scope.name
                                        }, _toDisplayString(scope.caption), 9, _hoisted_9)
                                    ], 64));
                                }), 256))
                            ])
                        ])
                    ]))
                    : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.configurator.groups, (item) => {
                    return (_openBlock(), _createElementBlock("div", {
                        class: "row ms-2 me-2",
                        key: item.name
                    }, [
                        _createElementVNode("div", _hoisted_10, [
                            _createElementVNode("div", _hoisted_11, [
                                _createElementVNode("div", null, [
                                    _createElementVNode("b", null, _toDisplayString(item?.caption), 1)
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                    (item.infoLink)
                                        ? (_openBlock(), _createBlock(_component_g_link, {
                                            key: 0,
                                            target: "modal",
                                            src: item.infoLink,
                                            class: "text-end"
                                        }, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_g_icon, {
                                                    src: "/assets/icons/info-square.svg",
                                                    class: "ms-1 mb-1 text-muted"
                                                })
                                            ]),
                                            _: 1
                                        }, 8, ["src"]))
                                        : _createCommentVNode("", true)
                                ])
                            ]),
                            _createElementVNode("div", _hoisted_13, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.values, (value) => {
                                    return (_openBlock(), _createElementBlock(_Fragment, {
                                        key: value.name
                                    }, [
                                        _createElementVNode("div", _hoisted_14, [
                                            _createElementVNode("div", _hoisted_15, [
                                                _createVNode(_component_DxCheckBox, {
                                                    modelValue: value.selected,
                                                    "onUpdate:modelValue": ($event) => ((value.selected) = $event),
                                                    "read-only": value.selected && value.actAsRadio,
                                                    onValueChanged: ($event) => (_ctx.handleValueChange(value, $event))
                                                }, null, 8, ["modelValue", "onUpdate:modelValue", "read-only", "onValueChanged"])
                                            ]),
                                            _createElementVNode("div", _hoisted_16, [
                                                _createElementVNode("div", null, [
                                                    _createTextVNode(_toDisplayString(value.caption) + " ", 1),
                                                    (value.infoLink)
                                                        ? (_openBlock(), _createBlock(_component_g_link, {
                                                            key: 0,
                                                            target: "modal",
                                                            src: value.infoLink
                                                        }, {
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_g_icon, {
                                                                    src: "/assets/icons/info-square.svg",
                                                                    class: "ms-1 mb-1 text-muted"
                                                                })
                                                            ]),
                                                            _: 1
                                                        }, 8, ["src"]))
                                                        : _createCommentVNode("", true)
                                                ]),
                                                (value.description)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_17, _toDisplayString(value.description), 1))
                                                    : _createCommentVNode("", true),
                                                (value.deliveryTime)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                                                        _createVNode(_component_g_product_delivery_time, {
                                                            options: value.deliveryTime,
                                                            class: "justify-content-start mt-1"
                                                        }, null, 8, ["options"])
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _createElementVNode("div", _hoisted_19, _toDisplayString(value.priceFormated), 1)
                                        ]),
                                        (value.entryField && value.entryField.type && value.selected)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_20, [
                                                _cache[1] || (_cache[1] = _createElementVNode("div", { class: "col-1" }, null, -1)),
                                                _createElementVNode("div", _hoisted_21, [
                                                    _createVNode(_component_g_text_field, {
                                                        "field-class": "mb-1",
                                                        "data-mode": "model",
                                                        "data-member": "entryValue",
                                                        label: value.entryField.placeholder ?? value.caption,
                                                        "show-label": false,
                                                        "data-object": value,
                                                        placeholder: value.entryField.placeholder,
                                                        "max-length": value.entryField.maxLength,
                                                        "validation-rules": { required: true }
                                                    }, null, 8, ["label", "data-object", "placeholder", "max-length"]),
                                                    (value.entryField.hint)
                                                        ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(value.entryField.hint), 1))
                                                        : _createCommentVNode("", true)
                                                ])
                                            ]))
                                            : _createCommentVNode("", true)
                                    ], 64));
                                }), 128))
                            ])
                        ])
                    ]));
                }), 128))
            ]),
            _cache[2] || (_cache[2] = _createElementVNode("div", { class: "mb-3 mt-2" }, [
                _createElementVNode("div", { class: "seperator" })
            ], -1))
        ], 64))
        : _createCommentVNode("", true);
}
